import React from 'react';
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CircularProgress from '@material-ui/core/CircularProgress';
import Box from '@material-ui/core/Box';
import {avanceResources, diferenciasResources} from "../endpoints";
import useToken from "../useToken";

function CircularProgressWithLabel(props) {
    return (
        <Box position="relative">
            <CircularProgress variant="determinate" {...props} size={85}/>
            <Box
                top={0}
                left={0}
                bottom={0}
                right={0}
                position="absolute"
                display="flex"
                alignItems="center"
                justifyContent="center"
            >

                <Typography variant="body1" component="div" >
                    {`${(Math.round(props.value* 1000)/1000)}%`}</Typography>
            </Box>
        </Box>
    );
}
class DashboardComponente extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            avance_general: 0,
            datos_avance: {
                avance: 0,
                cantidad: 0,
                cantidad_umb: 0,
                importe: 0,
                registros: 0,
                registros_revisados: 0,
                tag_contado: 0,
                tag_nulo: 0,
                tag_pendiente: 0,
                tag_total: 0
            },
            datos_diferencia: {
                descripcion: '',
                dif: 0,
                difimp: 0,
                inv: 0,
                invimp: 0,
                teo: 0,
                teoimp: 0,
            },
            diferencia_unidades: 0,
            diferencia_valorizado: 0,
            diferencia_general: 0,
            estado_inv: '',
            tipo_inv: ''
        };
    }

    avanceGeneral() {
        avanceResources.getAvanceGeneral().then(async response => {
            if (response) return await response.json();
        }).then(result => {
            if (result.status_code === 200) {
                this.setState({
                    avance_general: result.avance.avance * 100,
                    datos_avance: result.avance
                });
            } else {
                throw new Error('Something went wrong ...');
            }
        }).catch(error => {
            console.log(error);
        });
    }

    diferenciaGeneral = () => {
        diferenciasResources.getDiferenciaGeneral().then(async response => {
            if (response) return await response.json();
        }).then(result => {
            if (result.status_code === 200) {
                this.setState({ datos_diferencia: result.diferencia }, () => {
                    const { teo, inv, dif, difimp, teoimp } = this.state.datos_diferencia;
                    if (teo !== 0 && teo !== null) {
                        this.setState({
                            diferencia_general: (inv / teo) * 100,
                            diferencia_unidades: (dif / teo) * 100,
                            diferencia_valorizado: (difimp / teoimp) * 100,
                            tipo_inv: 'CON TEÓRICO'
                        });
                    } else {
                        this.setState({ tipo_inv: 'SIN TEÓRICO' });
                    }
                });
            } else {
                throw new Error('Something went wrong ...');
            }
        }).catch(error => {
            console.log(error);
        });
    }

    componentDidUpdate(prevProps) {
        if (prevProps.inv_elegido !== this.props.inv_elegido) {
            this.diferenciaGeneral();
            this.avanceGeneral();
            if (useToken.getDatos()){
                this.setState({estado_inv: useToken.getDatos().estado.toUpperCase()})
            }
        }
    }

    render() {
        return (
            <div>
                <Card style={{background: '#dbe9fc'}}>
                    <CardContent>
                        <Grid container spacing={2} wrap="wrap">
                            <Grid item xs={12} sm={6} md={2} container direction="column" spacing={1}>
                                <Grid item><b>Estado Inv:</b> {this.state.estado_inv}</Grid>
                                <Grid item><b>Supervisor:</b></Grid>
                                <Grid item><b>Tipo Inv:</b> {this.state.tipo_inv}</Grid>
                            </Grid>

                            <Grid item xs={12} sm={6} md={2} container direction="column" spacing={1}>
                                <Grid item><b>AVANCE POR ZONA</b></Grid>
                                <Grid item><b>Zonas
                                    contadas:</b> {new Intl.NumberFormat("de-DE").format(this.state.datos_avance.tag_contado)}
                                </Grid>
                                <Grid item><b>Zonas
                                    nulas:</b> {new Intl.NumberFormat("de-DE").format(this.state.datos_avance.tag_nulo)}
                                </Grid>
                                <Grid item><b>Total
                                    zonas:</b> {new Intl.NumberFormat("de-DE").format(this.state.datos_avance.tag_total)}
                                </Grid>
                            </Grid>

                            <Grid item xs={12} sm={6} md={2} container alignItems="center" justifyContent="center">
                                <CircularProgressWithLabel value={this.state.avance_general}/>
                            </Grid>

                            {this.state.tipo_inv !== 'SIN TEÓRICO' && (
                                <>
                                    <Grid item xs={12} sm={6} md={2} container direction="column" spacing={1}>
                                        <Grid item><b>AVANCE POR UNIDADES</b></Grid>
                                        <Grid item><b>Unidades
                                            contadas:</b> {new Intl.NumberFormat("de-DE").format(this.state.datos_avance.cantidad)}
                                        </Grid>
                                        <Grid item><b>Unidades
                                            teóricas:</b> {new Intl.NumberFormat("de-DE").format(this.state.datos_diferencia.teo)}
                                        </Grid>
                                    </Grid>

                                    <Grid item xs={12} sm={6} md={2} container alignItems="center"
                                          justifyContent="center">
                                        <CircularProgressWithLabel value={this.state.diferencia_general}/>
                                    </Grid>

                                    <Grid item xs={12} sm={6} md={2} container direction="column" spacing={1}>
                                        <Grid item><b>DIFERENCIAS</b></Grid>
                                        <Grid item><b>Por
                                            Unidades:</b> {new Intl.NumberFormat("de-DE").format(this.state.diferencia_unidades)} %</Grid>
                                        <Grid item><b>Por
                                            Valorizado:</b> {new Intl.NumberFormat("de-DE").format(this.state.diferencia_valorizado)} %</Grid>
                                    </Grid>
                                </>
                            )}
                        </Grid>
                    </CardContent>
                </Card>
            </div>

        );
    }

}

export default DashboardComponente;